module.exports = __webpack_public_path__ + "static/media/ImageSensor.09605714.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/ImageSensor.png
// module id = 2565
// module chunks = 0